module.exports = __webpack_public_path__ + "img/gb-whatsapp-promo-banner.c2b758bc.webp";